import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';

import { useModal } from 'components/Modal/Modal.hooks';
import { InfoModalProps } from 'components/Modal/Modal.types';

import styles from 'components/Modal/ModalTypes/InfoModal/InfoModal.module.scss';

const cn = classNames.bind(styles);

const InfoModal: FC<InfoModalProps> = ({
  iconName,
  heading,
  paragraphs,
  buttonText,
  buttonUrl,
  buttonWidth,
}) => {
  const { closeModal } = useModal();

  const renderIcon = () => {
    if (iconName) {
      return (
        <div className={cn('info-modal__icon-container')}>
          <img
            src={`/images/global/${iconName}.svg`}
            alt='Modal Window Icon'
          />
        </div>
      );
    } else {
      return null;
    }
  };

  const renderParagraphs = () => {
    if (paragraphs?.length) {
      return (
        <div className={cn('info-modal__description')}>
          {paragraphs.map((paragraph, index) => {
            return (
              <p
                className={cn('info-modal__description-paragraph')}
                key={index}
              >
                {paragraph}
              </p>
            );
          })}
        </div>
      );
    } else {
      return null;
    }
  };

  const renderButton = () => {
    if (buttonUrl) {
      return (
        <Link
          className={cn('info-modal__button')}
          style={{'width': buttonWidth || ''}}
          href={buttonUrl}
          onClick={closeModal}
        >
          {buttonText}
        </Link>
      );
    } else {
      return (
        <button
          className={cn('info-modal__button')}
          style={{'width': buttonWidth || ''}}
          onClick={closeModal}
        >
          {buttonText}
        </button>
      );
    }
  };

  return (
    <div className={cn('info-modal')}>

      {renderIcon()}

      <h4 className={cn('info-modal__heading')}>
        {heading}
      </h4>

      {renderParagraphs()}

      <div className={cn('info-modal__buttons')}>
        {renderButton()}
      </div>

    </div>
  );
};

export { InfoModal };